// Window inner height in pixels
export const SIDEBAR_COMPACT_VERSION_WINDOW_HEIGHT_THRESHOLD = 600;
